module.exports = __webpack_public_path__ + "img/02688.114d3e26.jpg";